import * as Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './auth'
import onboarding from './onboarding'
import elements from '@webapp/store/elements'

const userStorageKey = (userId) => `timebrella-state-${userId}`

const store = new Vuex.Store({
    plugins: [
        createPersistedState({
            paths: ['auth'],
        })
    ],
    modules: {
        auth,
        onboarding,
        elements,
    }
})

// Restore onboarding on page refresh (vuex-persistedstate uses replaceState, not mutations)
const restoredUserId = store.state.auth.user?.id
if (restoredUserId) {
    const saved = JSON.parse(localStorage.getItem(userStorageKey(restoredUserId)) || '{}')
    if (saved.onboarding) {
        store.commit('onboarding/RESTORE', saved.onboarding)
    }
}

// When user is set (login/fetchData), restore their onboarding state
// When onboarding changes, save to user-scoped storage
store.subscribe((mutation, state) => {
    if (mutation.type === 'auth/SET_USER' && mutation.payload?.id) {
        const key = userStorageKey(mutation.payload.id)
        const saved = JSON.parse(localStorage.getItem(key) || '{}')
        if (saved.onboarding) {
            store.commit('onboarding/RESTORE', saved.onboarding)
        }
    }

    if (mutation.type.startsWith('onboarding/') && mutation.type !== 'onboarding/RESTORE') {
        const userId = state.auth.user?.id
        if (userId) {
            const key = userStorageKey(userId)
            const saved = JSON.parse(localStorage.getItem(key) || '{}')
            saved.onboarding = state.onboarding
            localStorage.setItem(key, JSON.stringify(saved))
        }
    }
})

export const saveUserData = (store, key, value) => {
    const userId = store.state.auth.user?.id
    if (!userId) return
    const sKey = userStorageKey(userId)
    const saved = JSON.parse(localStorage.getItem(sKey) || '{}')
    saved[key] = value
    localStorage.setItem(sKey, JSON.stringify(saved))
}

export const loadUserData = (store, key) => {
    const userId = store.state.auth.user?.id
    if (!userId) return undefined
    const sKey = userStorageKey(userId)
    const saved = JSON.parse(localStorage.getItem(sKey) || '{}')
    return saved[key]
}

export default store
